import {ShopifyError} from '@shopify/shopify-api';

export class SessionNotFoundError extends ShopifyError {}
